// extracted by mini-css-extract-plugin
export default {"handle":"handle--sOIZa","handleResizing":"handleResizing--Ai4ue","handleDisabled":"handleDisabled--mgfcq"};